import React from 'react'
import { Typography, useAccessToken } from '@chilecompra/react-kit'
import { REACT_APP_SELLER_SEARCH_URL } from '../../config/settings/environment'
import { Link, Root, SearchIcon } from './SearchSellerSection.styles'

/**
 * Search seller section container.
 */
const SearchSellerSection = () => {
  const accessToken = useAccessToken()
  return (
    <Root>
      <Typography fontWeight="bold" variant="h4" tabIndex="0">
        Buscador de Proveedores
      </Typography>
      <Typography margin="14px 0" variant="body2" tabIndex="0">
        Accede al Buscador de Proveedores inscritos en Mercado Público.
      </Typography>
      <Link
        href={`${REACT_APP_SELLER_SEARCH_URL}/callback?access_token=${accessToken}&expires_in=28800`}
        rel="noreferrer"
        target="_self"
      >
        <SearchIcon />
        Ir al buscador de proveedores
      </Link>
    </Root>
  )
}

export default SearchSellerSection
